import {Component, OnInit, QueryList, ViewChild, ViewChildren }from '@angular/core'; 
import {NgForm }from '@angular/forms'; 
import {ActivatedRoute, ParamMap, Router }from '@angular/router'; 
import {ConfirmationService, Message }from 'primeng/api'; 
import {AppBreadcrumbService }from 'src/app/app.breadcrumb.service'; 
import {LookupValuesService }from 'src/app/common/lookup-values.service'; 
import {ValidateformComponent }from 'src/app/common/validateform/validateform.component'; 
import {MemberService }from 'src/app/services/MemberService'; 
import { Location } from '@angular/common';
import { AlertService } from 'src/app/services/AlertService';
import { environment } from 'src/environments/environment';
import { FileUpload } from 'primeng/fileupload';
import { AccountService } from '../../services/AccountService';

@Component({
  selector: 'app-member-edit',
  templateUrl: './member-edit.component.html',
  styleUrls: ['./member-edit.component.scss']
})
export class MemberEditComponent implements OnInit {
  @ViewChildren(FileUpload) pFileUploads: QueryList<any>;
  @ViewChild('f', { static: true }) editMemberForm: NgForm;
  @ViewChild(ValidateformComponent, { static: true })
  private formValidator: ValidateformComponent;
  memberid:any;
  member:any; 
  options:any; 
  memberTypeOptions:any[] = []; 
  officeTypeOptions:any[] = []; 
  countryOptions:any[] = []; 
  stateOptions:any[] = []; 
  parentOfficeOptions:any[] = []; 
  approvingManagerOptions:any[] = [];
  msgs:Message[]; 
  uploadURLLogo : string = '';
  uploadURLIcon: string = '';
    canEditMember: boolean = false;
    originalApprovingManager: number = 0;

  constructor(private router:Router, 
    private activatedRoute:ActivatedRoute, 
    private breadcrumbService:AppBreadcrumbService, 
    private lookupValuesService:LookupValuesService, 
    private memberservice:MemberService, 
    private confirmationService:ConfirmationService,
    private location: Location,
    private alertService: AlertService,
    private accountService: AccountService) { }
    public disableParentOfficedDropDown = false;
  ngOnInit():void {
  
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.memberid = parseInt(params.get('id'));   
      this.member = this.activatedRoute.snapshot.data['member'];       
      this.member.Logo = 'data:image/png;base64,' + this.member.Logo;
      this.member.Icon = 'data:image/png;base64,' + this.member.Icon;      
      this.breadcrumbService.setItems([{ label: 'Edit Member: ' + this.member.Name, routerLink: [] }]);    
      this.options = this.activatedRoute.snapshot.data['options'];
      this.parseOptions(); 
      this.onCountryChange();
      this.onOfficeTypeChange();
      this.uploadURLLogo  = environment.apiBase.concat('Member/UploadMemberImage?memberid=', this.memberid,'&imagetype=logo');
      this.uploadURLIcon  = environment.apiBase.concat('Member/UploadMemberImage?memberid=', this.memberid,'&imagetype=icon');
        this.canEditMember = this.accountService.CanEditMember(this.memberid);
        this.originalApprovingManager = this.member.ManagerID;
  });
 
  } 
  parseOptions() {

    this.memberTypeOptions = new Array(); 
    for (let o of this.options[0]) {
        let l = o.Name; 
        this.memberTypeOptions.push( {label:l, value:o.Id }); 
    }

    this.officeTypeOptions = new Array(); 
    for (let o of this.options[1]) {
        let l = o.Name; 
        this.officeTypeOptions.push( {label:l, value:o.Id }); 
    }

    this.countryOptions = new Array(); 
    for (let o of this.options[2]) {
        let l = o.Name; 
        this.countryOptions.push( {label:l, value:o.Id }); 
    }
    this.parentOfficeOptions = new Array(); 
    for (let o of this.options[3]) {
        let l = o.Name; 
        this.parentOfficeOptions.push( {label:l, value:o.Id }); 
    }

    if(this.member != null && this.member.AgentsAndStaff != null)
    {
      this.approvingManagerOptions = new Array(); 
      for (let o of this.member.AgentsAndStaff) {
          let l = o.FName + ' ' + o.LName; 
          this.approvingManagerOptions.push( {label:l, value:o.Id}); 
      }
    }      
  }
  onCountryChange() {
    if (this.member != null && this.member.CountryID != null) {
        this.lookupValuesService.GetStateOptions(this.member.CountryID).subscribe(
            res =>  {
                this.stateOptions = new Array(); 
                for (let o of res) {
                    let l = o.Name; 
                    this.stateOptions.push( {label:l, value:o.Id }); 
                }
            })
    }
  }
  onOfficeTypeChange()
  {
    if(this.member != null && this.member.OfficeTypeID != null)
    {
       if(this.member.OfficeTypeID == 1)
       {
          this.disableParentOfficedDropDown = true; 
       }
       else
       {
          this.disableParentOfficedDropDown = false; 
       }
    }
  }

  cancelEditMember() {
    this.confirmationService.confirm({
      key: "editMemberConfirmDialog",
      message: "All the changes will be lost.Are you sure you want cancel?",
      accept: () => {
          this.location.back();              
      }
  });
 
  }

  editMember() {                         
    if (this.formValidator.validateForm()) {
      this.memberservice.UpdateMember(this.member).subscribe(
          result => {            
            this.pFileUploads.forEach(pFileUpload => this.uploadFiles(pFileUpload));                 
            if (result!= null && result.Id != null) {       
              this.navigatetoMember(result.Id);                                              
            }
            else {
                this.alertService.SetMessage('error', 'There is an error while updating member');
            }                  
          },
          error => {                
                  this.alertService.SetMessage('error', 'There is an error while updating member');
          }
      );
    }
  }

  uploadFiles(pFileUpload: FileUpload)
  {
    if (pFileUpload.files.length > 0) {                  
       pFileUpload.upload();
    }   
  }
  navigatetoMember(Id)
  {
    this.router.navigate(['/member/'+ Id])  
  }
  onBeforeUploadLogo(event) {
    if (this.memberid != undefined && this.memberid != 0) {
      event.formData.append('memberid', this.memberid);
      event.formData.append('imagetype', 'logo');
    }
    else {
      event.xhr.abort();
      event.xhr = null;
      event.stopPropogation();
      this.alertService.SetMessage('error', 'There is an error while uploading file');
    }
  }

  onUploadCompletedLogo(event) {
    if (event.originalEvent.ok) {}
    else {
      this.alertService.SetMessage('error', 'There is an error while uploading file');
    }
  }
  onBeforeUploadIcon(event) {
    if (this.memberid != undefined && this.memberid != 0) {
      event.formData.append('memberid', this.memberid);
      event.formData.append('imagetype', 'icon');
    }
    else {
      event.xhr.abort();
      event.xhr = null;
      event.stopPropogation();
      this.alertService.SetMessage('error', 'There is an error while uploading file');
    }
  }

  onUploadCompletedIcon(event) {
    if (event.originalEvent.ok) {
      this.router.navigate(['']);
    }
    else {
      this.alertService.SetMessage('error', 'There is an error while uploading file');
    }
  }

    onChangeAppovingManager() {
        this.confirmationService.confirm({
            key: "editMemberConfirmDialog",
            message: "Are you sure you want to update the approving manager, this change will update all deals manager?",
            reject: () => {
                this.member.ManagerID = this.originalApprovingManager;
            }
        });
    }
}
